export const baseURL = process.env.NODE_ENV === "production" ? "http://dispatchadmin.huaweihezi.com" : "/api";
